// A small peice of boiler plate for Redux to create useAppDispatcher and useAppSelector
// hooks.  This is done to provide the TypeScript types in hooks that can be reused throughout
// the application.

import { useSelector, useDispatch, TypedUseSelectorHook } from 'react-redux'
import { AppDispatch, RootState } from 'store/store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
